var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 9.00008C6.08325 9.00008 5.33325 8.25008 5.33325 7.33342C5.33325 6.41675 6.08325 5.66675 6.99992 5.66675C7.91659 5.66675 8.66659 6.41675 8.66659 7.33342C8.66659 8.25008 7.91659 9.00008 6.99992 9.00008ZM11.9999 7.50008C11.9999 4.47508 9.79158 2.33341 6.99992 2.33341C4.20825 2.33341 1.99992 4.47508 1.99992 7.50008C1.99992 9.45008 3.62492 12.0334 6.99992 15.1167C10.3749 12.0334 11.9999 9.45008 11.9999 7.50008ZM6.99992 0.666748C10.4999 0.666748 13.6666 3.35008 13.6666 7.50008C13.6666 10.2667 11.4416 13.5417 6.99992 17.3334C2.55825 13.5417 0.333252 10.2667 0.333252 7.50008C0.333252 3.35008 3.49992 0.666748 6.99992 0.666748Z",
    fill: "#0085E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.674a3169d8ebdeb92cb304d30bb40f75.svg";
export { ForwardRef as ReactComponent };